export default __webpack_public_path__ + "static/media/CodyBaele.3d89d556.jpg";